
// ** 기본호출 **
// layer.openFn({ 'target' : '클래스명' });
// ** ajax 호출 **
// layer.openFn({ 'ajaxUrl' : 'url주소' });
// ** 닫기 **
// layer.closeFn( Call Back Function);

document.addEventListener('DOMContentLoaded' , () =>{
    const layer = (function(){
        const defaultOption = {
            target : '.layer',
            $target : document.querySelector('.layer'),
            ajaxUrl : undefined,
            ajaxCall : false,
            prevTarget : undefined,
            active : false
        }
        const bodyEl = document.querySelector('body');
        let option = {};
    
        const openFn = (newOption) => {
            if(option.prevTarget != undefined){
                closeFn( function(){
                    _openFn(newOption);
                });
            }else{
                _openFn(newOption);
            }
    
        }
    
        const closeFn = (callBackFn = undefined) => {
            if(option.$target.classList.contains('js-search-layer')){
                if(document.querySelector('.wrap--main')){
                    document.querySelector('.header').className = 'header header--type1 header--transparent';
                }
            }

            if(option.active){
                if( option.prevTarget == undefined ){
                    option.prevTarget = option.$target;
                }
                
                if( option.ajaxCall ){
                    option.prevTarget.parentNode.remove();
                    option.ajaxUrl = undefined;
                    option.ajaxCall = false;
                }else{
                    option.$target.style.display = 'none';
                }
    
                bodyEl.classList.remove('ovf');
                option.prevTarget = undefined;
                option.active = false;
                option = defaultOption;
                option.$target.querySelector('.layer__bg').remove();
    
                if( callBackFn !== undefined ){
                    callBackFn();
                }
            }
        }
        const ajaxCheck = () => {
            if( option.ajaxUrl != undefined ){
                fetch(option.ajaxUrl)
                    .then( response => {
                        // console.log(response);
                        if (response.ok) {
                            return response.text();
                        } else {
                            alert('네트워크 오류');
                        }
                    })
                    .then( html => {
                        let dom = document.createElement('div');
                        dom.innerHTML = html;
                        option.$target = dom.querySelector('.layer');

                        document.querySelector('.content').appendChild(dom);
                        
                        _showFn();
                        
                        option.ajaxCall = true;
                    })
                    .catch(function (err) {
                        alert(err)
                    });
            }else{
                _showFn();
            }
        }
    
        const _openFn = (newOption) => {
            option = Object.assign(defaultOption, newOption);
            option.$target = document.querySelector(option.target);
            
            ajaxCheck();
        }

        const _showFn = () => {
            if(option.$target.classList.contains('js-search-layer')){
                if(document.querySelector('.wrap--main')){
                    document.querySelector('.header').className = 'header header--type1';
                }

                //검색 레이어 transition
                setTimeout(function(){
                    document.querySelector('.js-search-layer').classList.add('active');
                }, 50);
        
                //검색 레이어 컨텐츠 transition
                const aniListArray = Array.from(document.querySelectorAll('.js-ani'));

                setTimeout(function(){
                    aniListArray[0].classList.add('show');
                }, 300);
                setTimeout(function(){
                    aniListArray[1].classList.add('show');
                }, 600);
                setTimeout(function(){
                    aniListArray[2].classList.add('show');
                }, 900);
                setTimeout(function(){
                    aniListArray[3].classList.add('show');
                }, 1200);
            }

            let addElement = document.createElement('div');

            option.$target.style.display = 'block';
            bodyEl.classList.add('ovf');
            addElement.className = 'layer__bg close';
            option.$target.appendChild(addElement);
            option.prevTarget = option.$target;
            option.active = true;
    
            let closeBtn = option.$target.querySelectorAll('.close');
    
            if(option.$target.classList.contains('js-search-layer')){
                closeBtn.forEach(function(el){
                    el.addEventListener('click' , function(){
                        document.querySelector('.js-search-layer').classList.remove('active');

                        setTimeout(function(){
                            closeFn();
            
                            //검색 레이어 컨텐츠 transition
                            const aniList = document.querySelectorAll('.js-ani');
            
                            aniList.forEach(function(el){
                                el.classList.remove('show');
                            })
                        }, 600);
                    });
                });
            }else if(option.$target.classList.contains('js-language-layer')){
                document.querySelector('.js-gnb-layer').style.display = "none";

                closeBtn.forEach(function(el){
                    el.addEventListener('click' , function(){
                        closeFn();
                    });
                });
            }else{
                closeBtn.forEach(function(el){
                    el.addEventListener('click' , function(){
                        closeFn();
                    });
                });
            }
        }
    
        const applyFn = () => {
            option = defaultOption;
    
            document.querySelectorAll('.layer_btn').forEach(el => {
                el.addEventListener('click' , function(){
                    const layerName = el.getAttribute('data-layer');
                    if(document.querySelector('.'+layerName)){
                        _openFn({ 'target' : '.'+layerName });

                        // 레이어 오픈 시, 가로값 설정
                        $('.slick-slider').slick('refresh');
                    }else{
                        alert('호출에 문제가 생겼습니다. [ 해당 레이어 없음 ]');
                    }
                });
            });
        }
    
        return {
            applyFn : applyFn,
            openFn : openFn,
            closeFn : closeFn
        }
    })();

    window.layer = layer;
    window.layer.applyFn();
});
